module.exports = __webpack_public_path__ + "static/img/backGround2.7e1ca75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backGround2.jpg
// module id = WTOI
// module chunks = 1